import { render, staticRenderFns } from "./system-form.vue?vue&type=template&id=0b712b84"
import script from "./system-form.vue?vue&type=script&lang=js"
export * from "./system-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports